module.exports = __webpack_public_path__ + "static/media/modelX_BackgroundPic.e2046587.jpg";